export default __webpack_public_path__ + "static/Sasha Abramovich-bd7e6123ae952e7a42e287f9418585f6.png";